<template>
  <div class="product-card" :class="CustomClass">
    <div class="card-header">
      <span class="product-name"> <i></i>{{ product.title }}</span>
      <template v-if="isApply">
        <van-button :loading="(product.loading||false)" loading-type="spinner" loading-text="申请中" class="btn-apply" @click="onSelete">立即申请</van-button>
      </template>
      <template v-else>
        <span class="protocol" @click="onProtocol">相关协议
          <svg xmlns="http://www.w3.org/2000/svg" width="9" height="15" viewBox="0 0 9 15" fill="none">
            <path d="M1.4834 13.3438L7.4834 7.34375L1.4834 1.34375" stroke="#525252" stroke-width="1.5"
              stroke-linecap="round" stroke-linejoin="round" />
          </svg></span>
      </template>
    </div>
    <template v-if="isApply">
       <div class="card-box">
      <div class="card-row">
        <span>{{ !isApply ? " 助贷机构：" : "服务机构：" }}</span>
        <span class="card-row-bold">{{ product.name }}</span>
      </div>
      <div class="card-row">
        <span>{{ !isApply ? "最高额度：" : "预估额度：" }}</span>
        <span class="card-row-highlight">{{ product.amount }}</span>
      </div>
      <div v-if="!isApply" class="card-row">
        利率：<span class="card-row-highlight">{{ product.rate }}</span>
        (以实际审核为准)
      </div>
      <i v-if="!isApply" class="selete" :class="{ 'active': product.isChecked }"></i>
    </div>
    </template>
    <template v-else>
       <div class="card-box" @click="onSelete">
      <div class="card-row">
        <span>{{ !isApply ? " 助贷机构：" : "服务机构：" }}</span>
        <span class="card-row-bold">{{ product.name }}</span>
      </div>
      <div class="card-row">
        <span>{{ !isApply ? "最高额度：" : "预估额度：" }}</span>
        <span class="card-row-highlight">{{ product.amount }}</span>
      </div>
      <div v-if="!isApply" class="card-row">
        利率：<span class="card-row-highlight">{{ product.rate }}</span>
        (以实际审核为准)
      </div>
      <i v-if="!isApply" class="selete" :class="{ 'active': product.isChecked }"></i>
    </div>
    </template>
   
  </div>
</template>

<script>
export default {
  name: "ProductCard",
  props: {
    CustomClass: {
      type: String,
      default: ""
    },
    product: {
      type: Object,
      default: () => ({}),
    },
    isApply: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
    };
  },
  watch: {
    value(newVal) {
      this.visible = newVal;
    },
    product: {
      immediate: true,
      deep: true,
      handler(newVal) {
      },
    },
  },
  methods: {
    handleVisibleChange(visible) {
      this.$emit("input", visible);
    },
    handleAgree() {
      this.$emit("agree");
      this.handleVisibleChange(false);
    },
    onSelete() {
      this.$set(this.product, 'loading',true)
      this.$set(this.product, 'isChecked',!this.product.isChecked)
      this.$emit('select', this.product);
    },
    onProtocol() {
      this.$emit("protocol", this.product);
    }
  },
};
</script>

<style lang="less" scoped>
.product-card {
  position: relative;
  border-radius: 16px;
  border: 4px solid #b9ddf2;
  background: #b9ddf2;
  box-shadow: 0 4px 13.5px 2px rgba(0, 0, 0, 0.02);
  margin-bottom: 10px;

  .card-header {
    display: flex;
    align-items: center;
    padding: 10px 16px 10px 16px;

    .product-name {
      color: #2e517b;
      font-size: 16px;
      font-style: normal;
      font-weight: 700;
      display: flex;
      align-items: center;

      i {
        display: inline-block;
        width: 28px;
        height: 28px;
        background-image: url("/images/icon-start.png");
        background-repeat: no-repeat;
        background-size: 100% 100%;
        margin-right: 8px;
      }
    }

    .protocol {
      margin-left: auto;
      font-size: 15px;
      color: rgba(0, 0, 0, 0.7);
      display: flex;
      align-items: center;

      svg {
        margin-left: 4px;
      }
    }

    .btn-apply {
      margin-left: auto;
      color: #FFF;
      text-align: center;
      font-size: 16px;
      font-style: normal;
      font-weight: 700;
      height: 32px;
      line-height: 32px;
      border-radius: 16px;
      background: #254774;
      border: none;
      display: flex;
      align-items: center;
      justify-content: center;
      margin-right: -14px;
    }
  }

  .card-box {
    padding: 16px;
    width: 100%;
    position: relative;
    border-radius: 16px;
    background: #fafdff;
    box-shadow: 0 4px 13.5px 2px rgba(0, 0, 0, 0.02);
  }

  .card-row {
    font-size: 14px;
    font-weight: 500;
    color: rgba(0, 0, 0, 0.7);
    margin-top: 16px;

    &:first-child {
      margin-top: 0;
    }
  }

  .card-row-bold {
    font-weight: 700;
    font-size: 15px;
  }

  .card-row-highlight {
    font-weight: 900;
    color: #ff6b00;
    font-size: 16px;
  }

  .selete {
    position: absolute;
    bottom: 5px;
    right: 5px;
    width: 32px;
    height: 32px;
    background-image: url("/images/icon-seleted.png");
    background-repeat: no-repeat;
    background-size: 100% 100%;
    cursor: pointer;

  }

  .selete.active {
    background-image: url("/images/icon-selete.png");
  }
}
</style>